export const OWNER_DETAILS = 'ownerDetails';
export const BUSINESS_DETAILS = 'businessDetails';

export type MyAccountTabs = typeof OWNER_DETAILS | typeof BUSINESS_DETAILS;

export interface MyAccount {
    currentTab: MyAccountTabs;
}
